// @flow
import styled from 'styled-components'
import { themedTextColor, themedTextColorRgb } from '../../styles'

const Link = styled.a`
  color: ${themedTextColor};
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: all 150ms ease-in;

  &:hover {
    border-bottom: 2px solid rgba(${themedTextColorRgb}, 0.3);
  }
`

export default Link



// WEBPACK FOOTER //
// ./src/components/typography/link.js